import { FetchError } from "ofetch";

export function create404Error() {
  return createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: false, // This prevents it from being logged as an error
  });
}

export function createFetchErrorMessage(error: FetchError | any, options: { defaultMessage?: string; unauthorizedMessage?: string } = {}) {
  if (import.meta.dev) {
    console.error("Exception calling fetch", {
      error: error, // string version
      errorData: error.data, // contains more information if it's a fetcherror
    });
  }

  let message = error.message || error.toString();

  if (error instanceof FetchError) {
    if (error.statusCode === 401 || error.statusCode === 403) {
      message = options?.unauthorizedMessage || "Invalid credentials";
    }
    else {
      message = error.data?.message || options?.defaultMessage || "An unknown error occurred";
    }

    message += ` (${error.statusCode})`;
  }

  return message;
}
